export { default as XboxIcon } from '~icons/mdi/microsoft-xbox';
